export enum InformationAccessLevel {
  None = "none",
  Read = "read",
  ReadWrite = "readWrite",
}

export interface IInformationTypeAccess {
  id: number;
  name: string;
  accessLevel: InformationAccessLevel;
}

export interface IInformationTypePermission {
  informationTypeId: number;
  informationTypeName: string;
  isActive: boolean;
  accessLevel: InformationAccessLevel;
}

export interface IInformationTypePermissionSet {
  roleId: number | null;
  groupId: number | null;
  permissions: IInformationTypePermission[];
}
